import React, { useEffect, useState } from "react";
import "./navBar.css";
import LogoNew from "../logoNew/logoNew";
import NavBarMobile from "./navBarMobile/navBarMobile";
import NavBarBurger from "./navBarBurger/navBarBurger";
import NavBarNavigationLinks from "./navBarNavigationLinks/navBarNavigationLinks";
import { Link } from "react-router-dom";
import BreadcrumbDisplay from "../breadcrumbDisplay/breadcrumbDisplay";
import Divider from "../divider/divider";
import { useSelector } from "react-redux";
import APIProductService from "../../services/APIProductService";

const NavBar = (props) => {
  const [active, setActive] = useState(false);
  const isLoggedIn = useSelector(
    ({ applicationUser }) => applicationUser?.isLoggedIn
  );
  const userName = useSelector(({ applicationUser }) => applicationUser?.name);
  const pageTitle = useSelector(({ pageTitle }) => pageTitle?.title);

  useEffect(() => {
    setActive(false);
  }, [props.location]);

  const toggleActive = () => {
    setActive(!active);
  };

  const isSwaggerPage =
    (props.location && props.location.startsWith("/apiProduct/") &&
      props.location.includes("/swagger/")) ||
    (props.location && props.location.startsWith("/swagger"));

  const handleDownloadSwagger = (e) => {
    e.preventDefault();
    try {
      const ok = APIProductService.downloadSwagger();
      if (!ok) {
        console.warn("Download Swagger not available.");
      }
    } catch (err) {
      console.error("Failed to download Swagger:", err);
    }
  };

  // Track Try Out validity from Swagger page via a global event
  const [tryoutValid, setTryoutValid] = useState(
    typeof window !== "undefined" ? !!window.swaggerTryOutValid : false
  );

  useEffect(() => {
    const handler = (e) => {
      setTryoutValid(!!(e?.detail && e.detail.valid));
    };
    window.addEventListener("swagger-tryout-validity", handler);
    // Initialize once on mount
    setTryoutValid(typeof window !== "undefined" ? !!window.swaggerTryOutValid : false);
    return () => window.removeEventListener("swagger-tryout-validity", handler);
  }, []);

  return (
    <div className="container menu">
      <Divider className="logo_dividerLeft" />
      <Divider className="logo_dividerRight" />
      <div className="main_menu">
        <Link to="/">
          <LogoNew />
        </Link>
        {pageTitle && (
          <div className="navbar-page-title">
            <span>{pageTitle}</span>
          </div>
        )}
        <nav>
          <NavBarBurger open={active} onChange={toggleActive} />
          <div className="nav-container">
            <NavBarNavigationLinks
              loggedIn={isLoggedIn}
              userName={userName}
              type="desktop"
            >
              {isSwaggerPage && (
                <li className="download_swagger_nav-button">
                  <a href="#" onClick={handleDownloadSwagger}>
                    DOWNLOAD
                  </a>
                </li>
              )}
              {isSwaggerPage && (
                <li className="tryout_nav-button">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.swaggerTryOutValid && window.triggerSwaggerTryOut) {
                        const ok = window.triggerSwaggerTryOut();
                        if (!ok) {
                          console.warn("Try Out action not available.");
                        }
                      } else {
                        console.warn("Try Out is not valid for the current selection.");
                      }
                    }}
                    aria-disabled={!tryoutValid}
                    style={{ opacity: tryoutValid ? 1 : 0.5, pointerEvents: tryoutValid ? "auto" : "none" }}
                  >
                    TRY OUT
                  </a>
                </li>
              )}
              {isSwaggerPage && (
                <li className="upload_swagger_nav-button">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.triggerSwaggerUpload) {
                        window.triggerSwaggerUpload();
                      } else {
                        console.warn("Upload trigger not available on this page.");
                      }
                    }}
                  >
                    UPLOAD
                  </a>
                </li>
              )}
            </NavBarNavigationLinks>
            <LogoNew className="mobile" />
            <NavBarMobile
              toggleMenu={toggleActive}
              loggedIn={isLoggedIn}
              userName={userName}
            >
              {isSwaggerPage && (
                <li className="download_swagger_nav-button">
                  <a href="#" onClick={handleDownloadSwagger}>
                    DOWNLOAD
                  </a>
                </li>
              )}
              {isSwaggerPage && (
                <li className="tryout_nav-button">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.swaggerTryOutValid && window.triggerSwaggerTryOut) {
                        const ok = window.triggerSwaggerTryOut();
                        if (!ok) {
                          console.warn("Try Out action not available.");
                        }
                      } else {
                        console.warn("Try Out is not valid for the current selection.");
                      }
                    }}
                    aria-disabled={!tryoutValid}
                    style={{ opacity: tryoutValid ? 1 : 0.5, pointerEvents: tryoutValid ? "auto" : "none" }}
                  >
                    TRY OUT
                  </a>
                </li>
              )}
              {isSwaggerPage && (
                <li className="upload_swagger_nav-button">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.triggerSwaggerUpload) {
                        window.triggerSwaggerUpload();
                      } else {
                        console.warn("Upload trigger not available on this page.");
                      }
                    }}
                  >
                    UPLOAD
                  </a>
                </li>
              )}
            </NavBarMobile>
          </div>
        </nav>
      </div>
      <Divider className="logo_dividerLeft" />
      <Divider className="logo_dividerRight" />
      <BreadcrumbDisplay />
    </div>
  );
};

export default NavBar;
